import assetPath from '/app/xinglets/startpage-logged-out/entry/src/companies-section/assets/ikea-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')